module.exports = __webpack_public_path__ + "img/medicimmo white  (1).4abe5e82.svg";